<div class="workspace-tab-panel w-100">
  <header class="workspace-section-head mb-4 text-start">
    <h1 class="mb-1">Orcaa.ai</h1>
    <p class="mb-0">Create learning content, assessments, and learner-ready resources with AI.</p>
  </header>

  <div class="workspace-card-grid w-100">
    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-purple d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa-solid fa-table gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Generate Full Courses With AI</h2>
          <p class="mb-0">Course Builder</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Upload notes, documents, videos, or type key topics. Orcaa turns your content into structured modules, lessons, summaries, activities, and optional assessments.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('courses')">
        Generate Course <span aria-hidden="true">&rarr;</span>
      </button>
    </article>

    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-sky d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa-solid fa-commenting gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Auto-Generate Assessments</h2>
          <p class="mb-0">Assessments & Rubrics</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Enter a topic or upload learning content. Orcaa creates questions, answers, difficulty levels, rubrics, and scoring guides.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('assessments')">
        Generate Assessment <span aria-hidden="true">&rarr;</span>
      </button>
    </article>

    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-mint d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa-solid fa-book gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Extract Key Information</h2>
          <p class="mb-0">Document Intelligence</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Upload reports, logbooks, PDFs, or assignments. Orcaa extracts skills, tasks, hours, outcomes, and structured insights instantly.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button">
        Upload Document <span aria-hidden="true">&rarr;</span>
      </button>
    </article>

    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-rose d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa-solid fa-bar-chart gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Enhance Learning Content</h2>
          <p class="mb-0">Content Refinement</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Improve clarity, structure, and engagement with summaries, rewritten notes, topic breakdowns, and learning-ready formats.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button">
        Enhance Content <span aria-hidden="true">&rarr;</span>
      </button>
    </article>
  </div>
</div>
